import { SetupTranslationSystemService } from "../services/system/setup-translation-system.service";
import { LoginApiService } from '../services/system/login-api.service';
import { TcmApplicationManagerService } from './tcm-application-manager.service';
import { TcmWebHubConnectionService } from './tcm-web-hub-connection.service';
import { ConfigService } from "../services/system/config.service";

export function applicationInitializer(
    configService : ConfigService,
    loginService: LoginApiService,
    setupTranslationSystemService: SetupTranslationSystemService,
    applicationManagerService: TcmApplicationManagerService,
    tcmWebHubConnectionService: TcmWebHubConnectionService) {
    return async () => {

        await loginService.refreshTokenAsync();

        await setupTranslationSystemService.initAsync();

        applicationManagerService.refreshApplicationPageIfRequired();

        tcmWebHubConnectionService.init();
    }
}
